import { toastManager } from "./toastManager";
import { ToastType } from "../types/toast";

/**
 * Глобальная функция локализации, устанавливается из LocalizationProvider
 */
let globalTranslate: ((key: string) => string) | null = null;

/**
 * Регистрирует функцию перевода для использования в showToast
 * Вызывается из LocalizationProvider
 */
export function registerTranslateFunction(
  translateFn: (key: string) => string,
): void {
  globalTranslate = translateFn;
}

/**
 * Отменяет регистрацию функции перевода
 */
export function unregisterTranslateFunction(): void {
  globalTranslate = null;
}

/**
 * Показывает toast уведомление с локализованным сообщением
 * Используется в утилитах и API клиентах где нужна локализация но нет доступа к React hooks
 *
 * @param localizationKey - ключ локализации
 * @param type - тип toast уведомления
 */
export function showToast(localizationKey: string, type: ToastType): void {
  if (globalTranslate) {
    const translatedMessage = globalTranslate(localizationKey);
    toastManager.show(translatedMessage, type);
  } else {
    // Fallback - показываем ключ если перевод недоступен
    console.warn(
      `[showToast] Translation not available, showing key: ${localizationKey}`,
    );
    toastManager.show(localizationKey, type);
  }
}

/**
 * Вспомогательные методы для разных типов уведомлений
 */
export const showToastSuccess = (localizationKey: string) =>
  showToast(localizationKey, ToastType.Success);
export const showToastError = (localizationKey: string) =>
  showToast(localizationKey, ToastType.Error);
export const showToastWarning = (localizationKey: string) =>
  showToast(localizationKey, ToastType.Warning);
export const showToastInfo = (localizationKey: string) =>
  showToast(localizationKey, ToastType.Info);
